
import React from 'react';
import { Link, Button, Menu, MenuItem } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import {ReactComponent as Logout} from '../../assets/images/logout_24dp.svg';
import Reports from '@material-ui/icons/Assessment';
import { UserContext } from '../../app';
import './style.css';

function ActiveUserMenu() {
  const { currentUser, handleLogoutUser } = React.useContext(UserContext);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    handleLogoutUser();
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}       
        onClick={handleClick}
      >
        <span className='userNameclass'>
          <AccountCircle/>{(currentUser?.firstName && currentUser?.lastName) ? currentUser.firstName +' '+ currentUser.lastName : ''}
        </span>
      </Button>
      <Menu
        id="basic-menu"       
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
        transformOrigin={{vertical: 'top', horizontal: 'center'}}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
      <Link color="inherit" href="/userprofile">
          <MenuItem >
          <AccountCircle/>Profile
          </MenuItem>
        </Link>
        {/* <MenuItem onClick={handleClose}>
          <Reports/>Reports
        </MenuItem> */}
        <Link color="inherit" href="/signin">
          <MenuItem onClick={handleLogout}>
            <Logout />Logout
          </MenuItem>
        </Link>
      </Menu>
    </div>
  );
}

export default ActiveUserMenu;
